import styled from "@emotion/styled";
import { DESKTOP } from "@/themes/device";
import { mHeader0, wHeader2 } from "@teamsparta/design-system";

export const Wrapper = styled.section`
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin: 0 auto;
  //width: 360px;
  position: relative;
  button {
    position: relative;
    margin-top: 50px;
  }
`;

export const Image = styled.div`
  position: relative;
  margin: 0 auto;
  width: 360px;
  height: 360px;
`;

export const Title = styled.h1`
  ${mHeader0};
  position: relative;
  color: white !important;
  text-align: center;
  ${DESKTOP} {
    ${wHeader2};
    br {
      &.mk-mo {
        display: none;
      }
    }
  }
`;
